import { Component, OnInit, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-loyalty-for-member-program-products',
    templateUrl: './loyalty-for-member-program-products.shared.component.html',
    styleUrls: ['./loyalty-for-member-program-products.shared.component.scss']
})
export class LoyaltyForMemberProgramProductsComponent implements OnInit {
    @Input() public slider: boolean = false;

    public programProductItems$!: Observable<OLO.Ordering.ILoyaltyProgramProductItemModel[]>;
    public loyaltyPoints$: Observable<OLO.Ordering.ILoyaltyPointsModel>;
    public loading$!: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.programProductItems$ = this.controllers.loyalty.getCurrentMemberLoyaltyProgramProducts$();
        this.loyaltyPoints$ = this.controllers.loyalty.getCurrentMemberLoyaltyPoints$();
        this.loading$ = this.controllers.loyalty.isLoadingLoyaltyInfoForMember$();
    }

}
